<div
  class="details-container"
  [style.filter]="showLoader ? 'blur(0.2rem)' : 'blur(0)'"
>
  <div fxLayout="column" class="container-list">
    <div
      fxLayout="column"
      class="card-container information-container"
      fxLayoutGap="10px"
      fxFlex="100%"
    >
      <div fxLayout="row" fxLayoutAlign="space-between">
        <div class="title-bloc">{{ aimsDataservice.res("notification") }}</div>

        <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5">
          <abc-button
            class="btn btn-light"
            icon="chevronprev"
            (onClick)="onHidePopUp()"
          ></abc-button>

          <abc-button
            class="btn btn-light"
            [icon]="isContextMenuVisible ? 'close' : 'overflow'"
            (onClick)="onOpenActionButtonsMenu($event)"
          ></abc-button>
        </div>
      </div>

      <abc-context-menu
        #contextMenuActions
        class="abc-context-menu"
        showEvent="abcclick"
        [items]="contextMenuItems"
        (onHidden)="onContextMenuHidden()"
        [position]="{ my: 'top right', at: 'bottom right' }"
      >
      </abc-context-menu>

      <div>
        <div class="element">
          <div class="title">ID</div>
          <div class="details strong">
            {{ identifier$ | async }}
          </div>
        </div>

        <div class="element">
          <div class="title">{{ aimsDataservice.res("designation") }}</div>
          <div
            class="details strong"
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            @if (notificationItem?.Icon) {
              <span [ngClass]="notificationItem.Icon" class="me-1"></span>
            }
            <span [innerHTML]="notificationItem?.Comment"></span>
          </div>
        </div>

        <div class="element">
          <div class="title">{{ aimsDataservice.res("date") }}</div>
          <div class="details strong">
            {{ notificationItem?.SysDateTimeInsert | Date }}
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="end end">
      <abc-button
        class="btn-Pfilchten-overview"
        stylingMode="text"
        [text]="aimsDataservice.res('notification-goToTheDetails')"
        (onClick)="navigateToDetails()"
      ></abc-button>
    </div>
  </div>
</div>

<confirmation-popup
  #markNotificationAsReadPopup
  [title]="aimsDataservice.res('confirm')"
  [message]="
    aimsDataservice.res(
      'notification-areYouSureYouWantToMarkThisNotificationAsRead?'
    )
  "
  [primaryBtnText]="aimsDataservice.res('yes')"
  [secondaryBtnText]="aimsDataservice.res('no')"
>
</confirmation-popup>

<notification-settings
  #notificationSettings
  [notificationSettings]="notificationItem"
  (updateNotification)="handleUpdateNotification($event)"
></notification-settings>
